<template>
  <iframe 
    v-if="isUrl" 
    :src="src" 
    frameborder="0" 
    style="width: 100%; height: 100%;" 
    :title="title || 'Eingebetteter Inhalt'"
    :aria-label="title || 'Eingebetteter Inhalt'"
    tabindex="0"
    role="application"
    @load="$emit('loadFinished', $event)"
    @focus="handleFocus"
    @blur="handleBlur"
    ref="iframe"
  ></iframe>
  <div v-else v-html="src"></div>
</template>

<script>
export default {
  props: {
    src: {
      type: String
    },
    title: {
      type: String
    }
  },
  computed: {
    isUrl () {
      return this.src.match(/^https?:\/\//)
    }
  },
  methods: {
    handleFocus() {
      this.$emit('iframe-focus')
    },
    handleBlur() {
      this.$emit('iframe-blur')
    }
  }
}

</script>